import Axios from 'axios';
import config from '../config';
import authorize from '../Utils/authorize';
import DefaultSettings from '../Utils/settings';

const URL = config.REACT_APP_API_URL

function Base(done, fail, url = URL, params = null) {
    const instance = Axios.create({
        baseURL: url,
        headers: {
            'Authorization': 'Bearer ' + authorize.getToken(),
            'Grant': authorize.getIdToken()
        },
        ...params
    })

    instance.interceptors.request.use(function (config) {
        if (DefaultSettings.getLoader() != null)
            DefaultSettings.getLoader().add();
        return config;
    }, function (error) {
        return Promise.reject(error);
    })

    instance.interceptors.response.use(function (response) {
        if (DefaultSettings.getLoader() != null)
            DefaultSettings.getLoader().remove();
        if (DefaultSettings.getAlert() != null && done !== null && done !== undefined)
            DefaultSettings.getAlert().show(done, 'success');
        return response
    }, function (error) {
        //const _originalRequest = error.config;
        if (error.response.status === 401) {
            // if (error.response.headers.pragma === 'Token-Expired' && !_originalRequest._retry) {
            //     _originalRequest._retry = true;
            //     return refresh(authorize.getToken(), authorize.getRefreshToken()).then(refreshResponse => {
            //         var _response = refreshResponse.data;
            //         authorize.setTokens('token', _response.token);
            //         authorize.setTokens('refreshToken', _response.refreshToken);
            //         _originalRequest.headers.Authorization = 'Bearer ' + _response.token;
            //         if (DefaultSettings.getLoader() != null)
            //             DefaultSettings.getLoader().remove();
            //         return Axios(_originalRequest);
            //     }).catch(err => {
            //         sessionStorage.clear()
            //         if (DefaultSettings.getLoader() != null)
            //             DefaultSettings.getLoader().remove();
            //         return Promise.reject(err);
            //     });
            // }
            // else {
            sessionStorage.clear()
            window.location.href = "/"
            /*if (DefaultSettings.getLoader() != null)
                DefaultSettings.getLoader().remove();
            if (DefaultSettings.getAlert() != null)
                DefaultSettings.getAlert().show(fail || 'Error Occurred', 'error');
            return Promise.reject(error);*/
            //}
        }
        else {
            if (DefaultSettings.getLoader() != null)
                DefaultSettings.getLoader().remove();
            const msg = error?.response?.data?.message || fail || 'Error Occurred';
            if (DefaultSettings.getAlert() != null)
                DefaultSettings.getAlert().show(msg, 'error');
            return Promise.reject(error);
        }
    });

    return instance;
}

export async function refresh(token, refreshToken) {
    return Axios.post(URL + '/Authorize/Refresh', { token, refreshToken })
}

export default function ApiAxios(done, fail, params = null) {
    return Base(done, fail, URL + '/api', params)
}
export const BaseAxios = Base